export enum Privacy {
  Public = "Public",
  Private = "Private"
}
